import numeral from 'numeral';

import { CountryCode, parsePhoneNumber as parsePhoneNumberFromString, PhoneNumber, ParseError } from 'libphonenumber-js';

import { i18nInstance } from 'i18n';
import { getCountryCode } from 'i18n/helpers';
import { CountryCode as i18nCountryCode } from 'i18n/types';
import { Address } from 'olo-service/models';

const ASSOCIATED_COUNTRY_CODES: { [K in i18nCountryCode]?: CountryCode[] } = {
  [i18nCountryCode.UNITED_STATES]: [i18nCountryCode.UNITED_STATES, 'PR', 'GU', 'VI', 'MP'],
};

export function parsePhoneNumber(phoneNumberString: string, defaultCountry: i18nCountryCode = getCountryCode(i18nInstance.language)): PhoneNumber {
  try {
    return parsePhoneNumberFromString(phoneNumberString, defaultCountry);
  } catch (error) {
    if (error instanceof ParseError && !defaultCountry && error.message === 'INVALID_COUNTRY') {
      // try again with a default merchantCountry
      return parsePhoneNumber(phoneNumberString, i18nCountryCode.UNITED_STATES);
    } else {
      throw error;
    }
  }
}

export const isPhoneNumberValid = (phoneNumberString?: string, countryCode?: i18nCountryCode) => {
  if (!phoneNumberString?.trim()) return false;

  try {
    const phoneNumberObj = parsePhoneNumber(phoneNumberString, countryCode);

    const isValid = !!phoneNumberObj?.isValid();

    if (phoneNumberObj?.country && countryCode) {
      const associatedCountryCodes: CountryCode[] = ASSOCIATED_COUNTRY_CODES[countryCode] || [countryCode];

      return associatedCountryCodes.includes(phoneNumberObj.country) && isValid;
    }

    return isValid;
  } catch (e) {
    return false;
  }
};

/**
 * @param phoneNumberString
 * @param defaultCountry - The country code that the phone number belongs to
 * @param customerCountry - The desired country format output
 */
export function formatPhoneNumber(phoneNumberString?: string, customerCountry: CountryCode = getCountryCode(i18nInstance.language)) {
  if (!phoneNumberString) return '';

  try {
    const number = parsePhoneNumber(phoneNumberString);

    if (customerCountry && number.country === customerCountry) {
      return number.formatNational();
    } else {
      return number.formatInternational();
    }
  } catch (e) {

    return '';
  }
}

export const fromCents = (value: number) => value / 100;

export const toCents = (value: number) => Math.floor(numeral(value).multiply(100).value() || 0);

export function formatAddress(mainAddress?: Address) {
  if (!mainAddress) return '';

  return [mainAddress.address1, mainAddress.city, mainAddress.state, mainAddress.zip].filter(Boolean).join(', ');
}
